import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Voltar",
	updateManyExternalIntegrations: {
		success: "Integrações atualizadas com sucesso",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronização pendente",
		pendingImporting: "Importação pendente",
	},
	ordersManager: {
		title: "Gestor de pedidos",
		description:
			"Acompanhe e gerencie os pedidos que chegam do Entregue já, Comanda Online e Pedido na mesa.",
		tabs: {
			newOrders: "Novos Pedidos",
			inDelivery: "Em entrega",
			completed: "Concluídos",
		},
		createOrder: "Criar novo pedido",
		selectMenuModal: {
			title: "Escolha o cardápio para fazer o pedido",
			searchPlaceholder: "Buscar por cardápio",
			productsCount: "{{value}} produtos",
			cancel: "Cancelar",
			select: "Selecionar cardápio",
			empty: "Nenhum cardápio encontrado.",
		},
		createOrderScreen: {
			back: "Voltar",
			searchPlaceholder: "Buscar por nome ou item do pedido",
			filterBy: "Filtrar por",
			allCategories: "Todas as categorias",
			all: "Todas",
			add: "Adicionar",
			added: "Adicionado",
			cartTitle: "Itens adicionados",
			emptyTitle: "Ainda não tem nada por aqui",
			emptyDescription: "Os itens irão aparecer assim que forem adicionados",
			subtotal: "Subtotal",
			discount: "Desconto",
			total: "Total",
			clear: "Limpar itens",
			finalize: "Finalizar pedido",
			emptyProducts: "Nenhum produto encontrado.",
			productDetail: {
				title: "Detalhes do produto",
				observationLabel: "Observações",
				observationPlaceholder: "Digite aqui uma observação do pedido",
				addProduct: "Adicionar produto",
				complementsRule: "Escolha até {{value}} opções",
				complementsRuleRequired: "Escolha de {{min}} a {{max}} opções",
			},
			clearModal: {
				title: "Limpar itens",
				description:
					"Tem certeza que deseja limpar os itens? Ao confirmar, você precisará adicioná-los novamente para finalizar.",
				cancel: "Cancelar",
				confirm: "Limpar itens",
			},
		},
		checkout: {
			back: "Voltar",
			title: "Pagamento do pedido",
			customerInfo: {
				title: "Informações do cliente",
				name: "Nome",
				namePlaceholder: "Insira nome e sobrenome do cliente",
				phone: "Telefone",
				phonePlaceholder: "Insira o número de telefone do cliente",
				cpf: "CPF",
				cpfPlaceholder: "Insira o número de CPF do cliente",
				sameWhatsapp: "O mesmo número para o Whatsapp",
			},
			delivery: {
				title: "Forma de entrega",
				pickup: "Retirar na loja",
				deliver: "Entregar via mobotoy",
				addressTitle: "Informações de endereço",
				cep: "CEP",
				cepPlaceholder: "Insira o CEP do cliente",
				street: "Rua",
				streetPlaceholder: "Insira o endereço do cliente",
				number: "Número",
				numberPlaceholder: "Insira o número",
				complement: "Complemento",
				complementPlaceholder: "Insira o complemento",
			},
			payment: {
				title: "Formas de pagamento",
				pix: "Pagamento via Pix",
			},
			summary: {
				title: "Resumo do pedido",
				deliveryFee: "Taxa de Entrega",
				total: "Total",
				finalize: "Finalizar pedido",
			},
		},
		filter: {
			placeholder: "Filtrar por",
			orderStatus: "Status do Pedido",
			paymentMethod: "Forma de Pagamento",
			orderOrigin: "Origem do Pedido",
			appliedFilters: "filtro(s) aplicado(s)",
		},
		loading: "Carregando",
		total: "Total: {{value}}",
		new: "Novo",
		emptyState: {
			title: "Ainda não temos pedidos {{status}}.",
			description: "Mostraremos aqui quando você receber novos pedidos.",
		},
		immersion: {
			enter: "Imersão",
			exit: "Sair da imersão",
		},
		sound: {
			on: "Som ligado",
			off: "Som mudo",
		},
		whatsNew: {
			intro: {
				title: "Temos novidades por aqui! 🎉",
				description: "Atualizamos o Gestor de pedidos. Bora ver rapidinho o que mudou?",
				start: "Ver novidades",
			},
			step: "Passo {{current}} de {{total}}",
			next: "Próximo",
			finish: "Entendi",
			skip: "Pular",
			test: "Tocar som de exemplo",
			immersion: {
				title: "Novo: Modo Imersão",
				description:
					"Deixe o gestor em tela cheia, sem menus, ideal para usar no balcão.",
			},
			sound: {
				title: "Novo: Som de pedido novo",
				description:
					"Tocamos um alerta sonoro quando chega um pedido novo. Use o botão para ligar ou silenciar.",
			},
		},
	},
	orderStatuses: {
		placed: "Pendentes",
		confirmed: "Aceitos",
		ready: "Prontos",
		dispatched: "Em entrega",
		concluded: "Concluídos",
		cancelled: "Cancelados",
	},
	deliveryStatus: {
		availableForPickup: "Disponível para retirada",
		availableForDelivery: "Disponível para entrega",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
